<template>
    <a :href="insuranceType.websiteUrl">
        <img :src="setLogo" :style="style" :alt="insuranceType.name" />
    </a>
</template>

<script>
// utils
import { mapState } from 'vuex';

import browser from '@/services/BrowserEvalService';

export default {
  name: 'logo',
  props: {
    imgMarginTop: String,
    imgWidth: String
  },
  computed: {
    ...mapState(['insuranceType']),
    setLogo() {
      let logo;
      if (browser.isIE) {
        this.imageType = 'png';
        logo = require.context('../../assets/header', false, /\.png$/);
      } else {
        this.imageType = 'svg';
        logo = require.context('../../assets/header', false, /\.svg$/);
      }
      return logo(`./${this.insuranceType.key.toUpperCase()}-Logo.${this.imageType}`);
    },
    style() {
      return {
        'margin-top': this.imgMarginTop,
        'width': this.imgWidth
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/logo.vue